import React, { FC, useEffect, useRef, useState } from "react";
import { Row, Col, Button, Modal, ModalBody, Label } from "reactstrap";
import { Controller, useFormContext } from "react-hook-form";
import FormInput from "../form-components/InputComponent";
import FormSelect from "../form-components/SelectComponent";
import supplierApis from "../../api/master/supplier";
import FormDatePicker from "../form-components/DatePicker";
import dayjs from "dayjs";
import invoiceApis from "../../api/Invoice/invoice";
import deliveryAddressApis from "../../api/master/deliveryAddress";
import { Popover, Tooltip, Modal as AntdModal, message, Space, Radio } from "antd";
import misc from "../../api/misc/dropDowns";
import purchaseOrderCreation from "../../api/purchase-orders/pruchaseOrderCreation";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchSequenceAccess } from "../../store/slices/misc/sequenceAccess";
import sequenceApis from "../../api/master/sequence";
import { InfoCircleOutlined, SettingOutlined } from "@ant-design/icons";
interface SelectOptions {
  label: string;
  value: any;
}
interface SequenceType {
  module: string;
  level: string;
  siteIds: string[];
}
const GeneralDetails: FC = (props: any) => {
  const {
    handleSubmit,
    watch,
    setValue,
    control,
    getValues,
    reset,
    formState: { errors },
  } = useFormContext();
  const dispatch: any = useDispatch();
  // const { data: sequenceAccess } = useSelector(
  //   (state: any) => state.sequenceAccess
  // );
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [sequenceAccess, setSequenceAccess] = useState<SequenceType>();
  const [supplierOptions, setSupplierOptions] = useState<any[]>([]);
  const [invoiceOptions, setInvoiceOptions] = useState<any[]>([]);
  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const [deliveryAddressOptions, setDeliveryAddressOptions] = useState<any[]>(
    []
  );
  const [activeSequences, setActiveSequences] = useState<any[]>([]);
  const [numberingMode, setNumberingMode] = useState<'auto' | 'manual'>('auto');
  const [showNumberingModal, setShowNumberingModal] = useState(false);
  const [tempNumberingMode, setTempNumberingMode] = useState<'auto' | 'manual'>('auto');

  const AllFormDetails = watch();
  const siteIdWatch = watch("siteId");
  const supplierIdWatch = watch("supplierId");
  const billingAddressId = watch("billingAddressId");
  const deliveryAddressId = watch("deliveryAddressId");
  const noteTypeWatch = watch("noteType");

  useEffect(() => {
    dispatch(fetchSequenceAccess());
  }, [dispatch]);
  useEffect(() => {
    if (supplierIdWatch) {
      fetchAllInvoicesForCreditDebitNote(supplierIdWatch);
      const _supplier = supplierOptions?.find(
        (item: any) => item.value == supplierIdWatch
      );
      if (!_supplier) return;
      setValue("supplierAddress", JSON.stringify(_supplier));
    }
  }, [supplierIdWatch]);

  useEffect(() => {
    if (billingAddressId) {
      const _address = deliveryAddressList?.find(
        (item: any) => item.id == billingAddressId
      );
      if (!_address) return;
      setValue("billingAddress", JSON.stringify(_address));
    }
  }, [billingAddressId]);

  useEffect(() => {
    if (deliveryAddressId) {
      const _address = deliveryAddressList?.find(
        (item: any) => item.id == deliveryAddressId
      );
      if (!_address) return;
      setValue("deliveryAddress", JSON.stringify(_address));
    }
  }, [deliveryAddressId]);

  useEffect(() => {
    if (noteTypeWatch === "Debit") {
      setValue("againstInvoice", "No");
    }
  }, [noteTypeWatch, setValue]);

  const ShowAddressPopOver = ({ id, text, options, matchKey }: any) => {
    if (!id) {
      return <></>;
    }

    let address = options?.find((item: any) => item[matchKey] == id);

    if (!address) {
      return <></>;
    }
    return (
      <Popover
        content={
          <ul>
            <li>
              {address?.addressLine1} {address?.addressLine2}
            </li>
            <li>
              {address?.city},{address?.districtName}, {address?.stateName},
              {address?.countryName} - {address?.pincode}
            </li>
          </ul>
        }
        title={address?.deliveryLocationName}
      >
        <a>{text}</a>
      </Popover>
    );
  };
  const submitForm = (data: any) => {
    console.log("data", data);
    setValue("numberingMode", numberingMode);
    props?.next();
  };

  const fetchSupplier = async () => {
    try {
      const res =
        await purchaseOrderCreation.fetchBuyerLinkedSupplierListMethod();
      const { data, status } = res;
      if (status) {
        let supplierOptions = data?.map((item: any) => {
          const { sellerOrg } = item;
          const { addresses } = sellerOrg;
          // if (addresses?.length == 0) {
          //   return {
          //     label: sellerOrg.name,
          //     value: sellerOrg.orgId?.toString(),
          //     addressLine1: "",
          //     addressLine2: "",
          //     country: "",
          //     state: "",
          //     district: "",
          //     city: "",
          //     pincode: "",
          //   };
          // }

          const {
            addressLine1,
            addressLine2,
            countryInfo,
            stateInfo,
            districtInfo,
            city,
            pincode,
          } = addresses;
          return {
            label: sellerOrg.name,
            value: sellerOrg.orgId,
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            country: countryInfo?.countryName,
            state: stateInfo?.stateName,
            district: districtInfo?.districtName,
            city: city,
            pincode: pincode,
          };
        });
        console.log("supplierOptions", supplierOptions);
        setSupplierOptions(supplierOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDeliveryAddress = async (siteId?: any) => {
    try {
      const { data, status } = await deliveryAddressApis.fetchAddressBySite(
        siteId
      );
      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllInvoicesForCreditDebitNote = async (id: any) => {
    try {
      const res = await invoiceApis.fetchAllInvoicesForCreditDebitNote(id);
      const { data, status } = res;

      if (status) {
        let options = data.map((item: any) => ({
          label: `Invoice - ${item.invoiceId}`,
          value: item.invoiceNumber,
        }));
        setInvoiceOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getSequenceAccess();
    fetchSupplier();
    const { noteType, supplierAddress } = AllFormDetails;
    if (noteType) {
      setValue("noteType", noteType);
    } else {
      setValue("noteType", "Credit");
    }
    if (supplierAddress) {
      setValue("supplierAddress", supplierAddress);
    }
  }, []);

  const getSequenceAccess = async () => {
    try {
      const response = await sequenceApis.fetchSequence();
      const { data } = response;
      const today = new Date();
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleName === "Credit Note/Debit Note" &&
          new Date(item.endDate) > today &&
          item.status === "Active"
      );
      setActiveSequences(_sequenceAccess || []);

      // Check if mode is already persisted in form (e.g. user navigated back from next step)
      const savedMode = getValues("numberingMode");
      if (savedMode) {
        setNumberingMode(savedMode);
        return;
      }

      if (_sequenceAccess && _sequenceAccess.length > 0 && siteIdWatch) {
        const siteHasSequence = _sequenceAccess.some(
          (seq: any) => seq.siteId?.toString() === siteIdWatch?.toString() || seq.level === 'Org'
        );
        setNumberingMode(siteHasSequence ? 'auto' : 'manual');
      } else {
        setNumberingMode('manual');
      }
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
      setActiveSequences([]);
      setNumberingMode('manual');
    }
  };

  const getCurrentSiteSequence = () => {
    if (!siteIdWatch || activeSequences.length === 0) return null;

    const siteSequence = activeSequences.find(
      (seq) =>
        seq.level === "Site" &&
        seq.siteId?.toString() === siteIdWatch?.toString()
    );

    if (siteSequence) return siteSequence;

    const orgSequence = activeSequences.find(
      (seq) => seq.level === "Org"
    );

    if (orgSequence) return orgSequence;

    return null;
  };

  const currentSiteSequence = getCurrentSiteSequence();
  const canAuto = !!siteIdWatch && !!currentSiteSequence;

  useEffect(() => {
    const existingValue = getValues("noteId");

    if (numberingMode === 'auto' && currentSiteSequence && !existingValue) {
      const { prefix, nextNumber } = currentSiteSequence;
      const poNumber = `${prefix}`;
      setValue('noteId', poNumber);
    }
  }, [numberingMode, currentSiteSequence]);

  const prevSiteRef = useRef();

  useEffect(() => {
    const prevSite = prevSiteRef.current;

    // Only run if site actually changed
    if (prevSite && prevSite !== siteIdWatch) {
      setValue("noteId", "");
      // Clear persisted mode so new site gets fresh evaluation
      setValue("numberingMode", "");
    }

    // Respect persisted mode on remount
    const savedMode = getValues("numberingMode");
    if (savedMode) {
      setNumberingMode(savedMode);
    } else if (!siteIdWatch) {
      setNumberingMode("manual");
    } else {
      const siteSequence = getCurrentSiteSequence();
      setNumberingMode(siteSequence ? "auto" : "manual");
    }

    prevSiteRef.current = siteIdWatch;
  }, [siteIdWatch]);

  useEffect(() => {
    if (siteIdWatch) {
      fetchSequenceAccess();
      fetchDeliveryAddress(siteIdWatch);
    } else {
      setDeliveryAddressOptions([]);
      setDeliveryAddressList([]);
    }
  }, [siteIdWatch]);

  useEffect(() => {
    if (currentUser) {
      let sitesOptions = currentUser?.siteAccessibility?.map((item: any) => ({
        label: item.siteName,
        value: item.siteID.toString(),
      }));
      setSitesOptions(sitesOptions);
    }
  }, [currentUser]);

  return (
    <>
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col lg="4">
            <FormSelect
              name="siteId"
              label={`Site`}
              options={sitesOptions}
              onChange={(e: String, data: SelectOptions) => {
                setValue("siteName", data.label);
              }}
              required={true}
              placeholder="-Select-"
            />
          </Col>
          
          <Col lg="4">
            <div style={{ position: 'relative' }}>
              <FormInput
                name="noteId"
                label="Note Number"
                required={numberingMode === 'manual'}
                disabled={numberingMode === 'auto' || AllFormDetails?.type === "draft"}
                placeholder={numberingMode === 'auto' ? 'Auto-generated' : 'Enter Note Number'}
              />
              <Tooltip title="Click here to enable or disable auto-generation of note numbers.">
                <SettingOutlined
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50px',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '18px',
                    color: '#1890ff',
                    zIndex: 1,
                  }}
                  onClick={() => {
                    setTempNumberingMode(numberingMode);
                    setShowNumberingModal(true);
                  }}
                />
              </Tooltip>
            </div>
          </Col>

          <Col lg="8">
            <FormInput
              name="description"
              label="Description"
              required={true}
              type="text"
              minLength={2}
              maxLength={500}
              placeholder="Enter Description"
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="supplierId"
              label={`Supplier/Vendor${supplierOptions.length == 0 ? "( Empty Supplier List)" : ""
                }`}
              options={supplierOptions?.map((item: any) => ({
                label: item.label,
                value: item.value,
              }))}
              required={true}
              placeholder="-Select-"
            />
          </Col>

          <Col lg="4">
            <FormSelect
              name="noteType"
              label="Note Type"
              options={[
                { label: "Debit", value: "Debit" },
                { label: "Credit", value: "Credit" },
              ]}
              required={true}
              placeholder="-Select-"
            />
          </Col>
          {/* <Col lg="4">
            <FormDatePicker
              name="dueDate"
              label="Due Date"
              minDate={new Date()}
            />
          </Col> */}
          <Col lg="4">
            <FormDatePicker
              name="noteDate"
              label="Credit Note Date"
              required={true}
              maxDate={new Date()}
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="approvalRequired"
              label="Supplier Approval Required ?"
              options={[
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
              ]}
              placeholder="Select"
              disabled={!siteIdWatch}
              required={true}
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="againstInvoice"
              label="Against Invoice"
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              placeholder="-Select-"
              required={true}
              disabled={noteTypeWatch === "Debit"}
            />
          </Col>

          {watch("againstInvoice") == "Yes" && (
            <Col lg="4">
              <FormSelect
                name="invoiceNumber"
                label="Invoice"
                options={invoiceOptions}
                required={true}
                placeholder="Select Invoice"
              />
            </Col>
          )}
          <Col lg="4">
            <FormInput
              name="referenceNumber"
              label="Reference #"
              type="text"
              placeholder="Enter Reference Number"
            />
          </Col>
          {watch("againstInvoice") != "Yes" && (
            <>
              <Col lg="4">
                <FormSelect
                  name="billingAddressId"
                  label={`Billing Address${deliveryAddressOptions.length == 0
                    ? "( Empty Billing Address List)"
                    : ""
                    }`}
                  options={deliveryAddressOptions}
                  popOverOptions={
                    <ShowAddressPopOver
                      id={billingAddressId}
                      matchKey="id"
                      options={deliveryAddressList}
                      text="View Selected Billing Address"
                    />
                  }
                  required={true}
                  placeholder="-Select-"
                />
              </Col>
              <Col lg="4">
                <FormSelect
                  name="deliveryAddressId"
                  label={`Delivery Address${deliveryAddressOptions.length == 0
                    ? "( Empty Delivery Address List)"
                    : ""
                    }`}
                  options={deliveryAddressOptions}
                  popOverOptions={
                    <ShowAddressPopOver
                      id={deliveryAddressId}
                      matchKey="id"
                      options={deliveryAddressList}
                      text="View Selected Delivery Address"
                    />
                  }
                  required={true}
                  placeholder="-Select-"
                />
              </Col>
            </>
          )}
          <Col lg="8">
            <FormInput
              name="remarks"
              label="Remarks"
              type="text"
              placeholder="Enter Remarks"
            />
          </Col>
        </Row>
        <Row className="gy-4 mt-1">
          <Col>
            <Button color="primary" type="submit">
              Next
            </Button>
          </Col>
        </Row>
      </form>

      {/* Note Number Configuration Modal  */}
      <AntdModal
        title="Configure Note Number Preference"
        open={showNumberingModal}
        onCancel={() => setShowNumberingModal(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}>
            <Button
              key="save"
              color="primary"
              onClick={() => {
                if (tempNumberingMode === "auto" && !currentSiteSequence) {
                  message.error("Auto-generation is not configured for this site.");
                  return;
                }

                setNumberingMode(tempNumberingMode);

                if (tempNumberingMode === "auto" && currentSiteSequence) {
                  const { prefix } = currentSiteSequence;
                  const noteNumber = `${prefix}`;
                  setValue("noteId", noteNumber);
                } else if (tempNumberingMode === "manual") {
                  setValue("noteId", "");
                }
                setShowNumberingModal(false);
              }}
            >
              Save
            </Button>

            <Button
              key="cancel"
              color="primary"
              onClick={() => setShowNumberingModal(false)}
            >
              Cancel
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 20, lineHeight: "22px" }}>
          Your note numbers are currently set to auto-generate to save time.
          <br />
          Are you sure you want to change this setting?
        </div>

        {!siteIdWatch && (
          <div style={{ color: "#8c8c8c", marginBottom: 16 }}>
            <InfoCircleOutlined /> Sequence configuration is not set for this site. Please configure the sequence.
          </div>
        )}

        {siteIdWatch && !currentSiteSequence && (
          <div style={{ color: "#faad14", marginBottom: 16 }}>
            <InfoCircleOutlined />{" "}
            {activeSequences.length === 0
              ? "No sequences configured for Credit Note/Debit Note. Please set up a sequence first."
              : "No sequence configured for the selected site. Please set a sequence for this site."}
          </div>
        )}

        <Radio.Group
          onChange={(e) => setTempNumberingMode(e.target.value)}
          value={tempNumberingMode}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Radio value="auto" disabled={!canAuto}>
              <span style={{ fontWeight: 500 }}>
                Continue auto-generating note numbers
              </span>
            </Radio>

            <Radio value="manual">
              <span style={{ fontWeight: 500 }}>
                Enter note numbers manually
              </span>
            </Radio>
          </Space>
        </Radio.Group>
      </AntdModal>
    </>
  );
};

export default GeneralDetails;
